import React, { lazy, Suspense } from "react";
import Pageloader from "../Loader";

const PreviewComp = lazy(() => import("./preview.js"));

const C = (p) => <Suspense fallback={<Pageloader />}>{p.Child}</Suspense>;
const Preview = (p) => <C Child={<PreviewComp {...p} />} />;

export default Preview;
